// extracted by mini-css-extract-plugin
export default {"Overlay":"user-notice-popover-module__Overlay__Hg8IH4a"};